module.exports = __webpack_public_path__ + "img/tichagnsu-poster.9cf4fbe2.jpg";